// src/components/CandlestickChart.js
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
  ErrorBar
} from 'recharts';

const CandlestickChart = ({ data, darkMode }) => {
  // Transform data for candlestick representation
  const chartData = data.map(item => ({
    ...item,
    // For candlestick using ErrorBar technique
    highLow: [item.low, item.high],
    openClose: [item.open, item.close],
    isUp: item.close >= item.open
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className={`p-4 rounded-lg shadow-lg ${
          darkMode ? 'bg-gray-800 border border-gray-600' : 'bg-white border border-gray-200'
        }`}>
          <p className="font-bold">{data.time}</p>
          <p>Open: <span className="font-semibold">${data.open.toFixed(2)}</span></p>
          <p>High: <span className="font-semibold">${data.high.toFixed(2)}</span></p>
          <p>Low: <span className="font-semibold">${data.low.toFixed(2)}</span></p>
          <p>Close: <span className="font-semibold">${data.close.toFixed(2)}</span></p>
          <p className={data.close >= data.open ? 'text-green-600' : 'text-red-600'}>
            {data.close >= data.open ? '▲' : '▼'} 
            ${Math.abs(data.close - data.open).toFixed(2)}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? '#374151' : '#e5e7eb'} />
        <XAxis 
          dataKey="time" 
          tick={{ fill: darkMode ? '#d1d5db' : '#4b5563' }}
        />
        <YAxis 
          tick={{ fill: darkMode ? '#d1d5db' : '#4b5563' }}
          domain={['auto', 'auto']}
        />
        <Tooltip content={<CustomTooltip />} />
        
        {/* Candlestick bodies using Bar with ErrorBar for wicks */}
        <Bar 
          dataKey="openClose" 
          fill={darkMode ? '#1f2937' : '#f3f4f6'}
          stroke={darkMode ? '#4b5563' : '#9ca3af'}
          barSize={8}
        >
          {chartData.map((entry, index) => (
            <ErrorBar
              key={index}
              dataKey="highLow"
              width={0}
              stroke={entry.isUp ? (darkMode ? '#10b981' : '#059669') : (darkMode ? '#ef4444' : '#dc2626')}
              strokeWidth={2}
            />
          ))}
        </Bar>

        {/* Colored bars for up/down days */}
        <Bar 
          dataKey={(entry) => entry.isUp ? entry.close - entry.open : 0}
          fill={darkMode ? '#10b981' : '#059669'}
          barSize={6}
          stackId="a"
        />
        <Bar 
          dataKey={(entry) => !entry.isUp ? entry.open - entry.close : 0}
          fill={darkMode ? '#ef4444' : '#dc2626'}
          barSize={6}
          stackId="a"
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CandlestickChart;